/**
 * Site Panel Constants
 * Constants used across site-related components
 */

// Work animation duration
export const WORK_ANIMATION_DURATION = 3 // Real seconds

// Image dimensions and positions
export const ESTIMATED_IMAGE_HEIGHT = 400
export const CONTENT_AREA_OFFSET = 120
export const DIG_DES_Y_OFFSET = 40

// Progress bar position
export const PROGRESS_BAR_Y = 60 // Y position from bottom of bg

// Work room constants
export const CONTAINER_HEIGHT = 600 // Tool container height
export const TOOL_BUTTON_Y = 120 // Y position from bottom of container
export const BUTTON_WIDTH = 80 // Estimated button width (btn_tool.png)
export const WORK_IMAGE_WIDTH = 500
export const WORK_IMAGE_HEIGHT = 400 // Estimated height for work_dig images

// Work room storage view constants
export const EQUIP_PANEL_HEIGHT = 125
export const SEPARATOR_HEIGHT = 10

